<template lang="pug">
    div
        div.no-data-selected(v-if='!socioDemoSettings.behavioral')
            p Extra taxonomies are not available.
                br
            | You have to activate the
            |
            span(@click="$emit('activeSocioDemo')") behavioral dimension
            |
            | in the
            |
            span(@click="$emit('activeSocioDemo')") Socio-demographics
            |
            | section.
            
        template(v-else)
            template(v-if='extraTaxoIsLoading && extraTaxoOwners.length === 0')
                spinner.l-flex-row--center.l-align-center(width='200', height='200')
                    div.settings-content-general(v-if='settingsMenu === "extra-taxos"')

            template(v-else-if='!extraTaxoIsLoading && extraTaxoOwners.length === 0')
                div.l-flex-row--center.l-align-center
                    div.settings-content-general There is no taxonomies for your account

            template(v-else)
                sectionHeader.w-360(title='extra taxonomies', :counter='numberOfActiveTaxos' :counterLimit='20')
                    template(slot='subHeader')
                        div.subheader you can activate a maximum of 20 taxonomies.

                div.l-2-col.settings-extra-taxos

                    .l-col-left
                        div.settings-section.settings-section-owners
                            .settings-section-title Owners
                            ul.owners-list.scrollbar.is-scrollable
                                li.owners-item(
                                    v-for='(owner, key) in extraTaxoOwners'
                                    :key='key'
                                    @click='displayTaxos(owner)'
                                    :class='{ "is-selected": selectedOwner === owner }')
                                    div.single-taxo-counter.l-flex-row--between
                                        div {{ owner }}
                                        div {{retrieveExtraTaxosCounter(owner)}}

                    .l-col-right
                        div.settings-section.settings-section-taxonomies

                            div.settings-section-title.l-flex-row
                                |
                                |
                                div.l-flex-row
                                    div Taxonomies of
                                    span.selected-owner {{ selectedOwner }}
                                span.selected-owner {{ retrieveExtraTaxosCounter(selectedOwner) }}
                            ul.taxos-list.scrollbar.is-scrollable
                                li.taxos-item.l-flex-row.l-align-center(v-for='(taxo, key) in currentExtraTaxo')
                                    switchItem(
                                        :key='key'
                                        :label='taxo.label'
                                        :fullData='taxo'
                                        type='extraTaxo'
                                        :inputName='selectedOwner'
                                        @taxoUpdated='taxoUpdated = true'
                                        :isSwitchActive='taxo.status === "active"'
                                        :isDisabled='numberOfActiveTaxos >= 20 && taxo.status === "inactive"'
                                        :isEditable='true'
                                        :class="{'is-edited': isTaxoLabelEditing}"
                                        :extraTaxoRatio='retrieveExtraTaxosCounter(taxo.label)'
                                        parent="extraTaxo"
                                        @editLabel='val => isTaxoLabelEditing = val'
                                        @taxoLabelUpdated='taxoLabelUpdated = true'
                                    )
                            div.l-flex-row--rev
                                button(@click="cancelExtraTaxoChanges()").btn.btn--medium.btn--round Cancel
                                button.btn.btn--medium.btn--round.btn-rev.btn-save-audience(
                                    :class="disableExtraTaxoBtn"
                                    @click="handleRequestUpdateExtraTaxo()") Save
</template>
<script>
//components
import SectionHeader from '@/components/common/SectionHeader'
import SwitchItem from '@/components/common/SwitchItem'

//store
import { mapState, mapActions, mapMutations } from 'vuex'

import { get, isEqual, keys, forEach, cloneDeep } from 'lodash'

export default {
    components: {
        SectionHeader, 
        SwitchItem,
    },

    data() {
        return {
            settingsMenu: 'extra-taxos',
            extraTaxo: null,
            selectedOwner: 'default',
            isTaxoLabelEditing: false,
            taxoLabelUpdated: false,
            taxoUpdated: false,
        }
    },

    computed: {
        ...mapState('data/settings', {
            extraTaxoSettings: state => state.extraTaxo,
            socioDemoSettings: state => state.sociodemo,
        }),
        ...mapState('ui/settings', {
            uiExtraTaxoSettings: state => state.extraTaxo,
        }),

        extraTaxoIsLoading() {
            return this.uiExtraTaxoSettings.isLoading
        },
        numberOfActiveTaxos() {
            return this.uiExtraTaxoSettings.activeTaxo
        },
        extraTaxoList() {
            return this.uiExtraTaxoSettings.list
        },
        extraTaxoOwners() {
            return keys(this.extraTaxoList)
        },
        currentExtraTaxo: {
            get() {
                return get(this.extraTaxoList, this.selectedOwner, [])
            },
            set(val) {
                this.extraTaxo = val
            }
        },
        disableExtraTaxoBtn() {
            return { 'ui-disabled': isEqual(this.extraTaxoList, this.extraTaxoSettings.list) }
        },
    },

    methods: {
        ...mapActions('data/settings', ['requestUpdateExtraTaxo']),

        ...mapMutations('ui/settings', [
            'setTotalActiveTaxos',
            'resetExtraTaxos',
        ]),

        // EXTRA-TAXOS
        displayTaxos(owner) {
            this.selectedOwner = owner
            this.currentExtraTaxo = get(this.extraTaxoList, `${owner}`, [])
        },

        retrieveExtraTaxosCounter(taxoOwner) {
            let totalExtraTaxos = 0
            let activeExtraTaxos = 0
            const isDefaultTaxoActive = this.extraTaxoList['default'][0].status === 'active'

            if (taxoOwner !== 'default') {
                for (const singleTaxoOwner in this.extraTaxoList) {
                    if (this.extraTaxoList[singleTaxoOwner][0].owner === taxoOwner) {
                        forEach(this.extraTaxoList[singleTaxoOwner], extaTaxo => {
                            if (extaTaxo.status === 'active') {
                                activeExtraTaxos++
                            }
                            totalExtraTaxos++
                        })
                    }
                }
            } else {
                // need to manage the case differently because the default taxonomy is wb => gt
                // https://weborama.atlassian.net/browse/WAM-7606
                totalExtraTaxos = 1
                activeExtraTaxos = isDefaultTaxoActive ? 1 : 0
            }

            // adjusting wb counter to compensate the treatment of default
            if (taxoOwner === 'wb') {
                totalExtraTaxos = totalExtraTaxos - 1
                isDefaultTaxoActive ? activeExtraTaxos-- : activeExtraTaxos
            }

            return activeExtraTaxos + ' / ' + totalExtraTaxos
        },

        // extra taxo
        cancelExtraTaxoChanges() {
            this.resetExtraTaxos({ previousExtraTaxos: cloneDeep(this.extraTaxoSettings) })
        },

        handleRequestUpdateExtraTaxo() {
            this.requestUpdateExtraTaxo()
            this.taxoLabelUpdated = false
            this.taxoUpdated = false
        },

    }
}
</script>